import { render } from "./EntranceAEModal.vue?vue&type=template&id=b2b19e46&ts=true"
import script from "./EntranceAEModal.vue?vue&type=script&lang=ts"
export * from "./EntranceAEModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__